/**
 * RelatedLinksContent - 相关链接渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';

export default function RelatedLinksContent({ data, mode = 'view', templateType }) {
  if (!data || !data.links || data.links.length === 0) return null;

  const enabledLinks = data.links.filter(link => link.enabled !== false);
  if (enabledLinks.length === 0) return null;

  // 数据驱动布局与样式
  const layout = data.layout || 'grid'; // grid | vertical-card | horizontal-row
  const cs = data.cardStyle || {};
  const logoSize = Number(data.logoSize || (layout === 'vertical-card' ? 72 : 36));
  const textColor = cs.textColor || (templateType === 'standard-food-label' ? 'var(--template-text-color)' : '#202124');
  const cardStyle = {
    background: cs.bgColor || 'transparent',
    border: cs.borderWidth ? `${cs.borderWidth}px solid ${cs.borderColor || '#e8eaed'}` : (layout === 'vertical-card' ? '1px solid #e8eaed' : 'none'),
    borderRadius: (cs.radius ?? (layout === 'vertical-card' ? 12 : 8)) + 'px',
    boxShadow: cs.shadow ? '0 6px 16px rgba(0,0,0,0.08)' : (layout === 'vertical-card' ? '0 6px 16px rgba(0,0,0,0.06)' : 'none'),
    padding: (cs.padding ?? (layout === 'vertical-card' ? 16 : 12)) + 'px',
    color: textColor,
    textDecoration: 'none'
  };

  if (layout === 'vertical-card') {
    return (
      <div className="label-content-related-links">
        {enabledLinks.map((link, idx) => {
          // 支持空icon时展示一个占位的圆形徽记效果（更接近截图）
          const iconSrcRaw = typeof link.icon === 'string' && link.icon.startsWith('data:') ? link.icon : (link.icon || '');
          const iconSrc = iconSrcRaw ? getProxyUrl(iconSrcRaw) : '';
          return (
            <a key={idx} href={link.url} target="_blank" rel="noreferrer" className="link-logo-card" style={cardStyle}>
              {iconSrc ? (
                <img
                  src={iconSrc}
                  alt={link.name || 'Logo'}
                  style={{ width: logoSize, height: logoSize, objectFit: 'contain' }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              ) : (
                <span style={{
                  width: logoSize,
                  height: logoSize,
                  borderRadius: logoSize / 2,
                  background: '#f59e0b',
                  display: 'inline-block'
                }} />
              )}
              <span className="link-logo-text" style={{ color: textColor }}>{link.name || '相关链接'}</span>
            </a>
          );
        })}
      </div>
    );
  }

  if (layout === 'horizontal-row') {
    return (
      <div className="label-content-related-links">
        {enabledLinks.map((link, idx) => {
          const iconSrcRaw = typeof link.icon === 'string' && link.icon.startsWith('data:') ? link.icon : (link.icon || '');
          const iconSrc = iconSrcRaw ? getProxyUrl(iconSrcRaw) : '';
          return (
            <a key={idx} href={link.url} target="_blank" rel="noreferrer" className="related-link-item" style={cardStyle}>
              {iconSrc ? (
                <img 
                  src={iconSrc} 
                  alt={link.name || 'Logo'} 
                  style={{ width: logoSize, height: logoSize, objectFit: 'contain' }} 
                  onError={(e) => { e.target.style.display = 'none'; }} 
                />
              ) : (
                <span style={{
                  width: logoSize,
                  height: logoSize,
                  borderRadius: logoSize / 2,
                  background: '#f59e0b',
                  display: 'inline-block',
                  flexShrink: 0
                }} />
              )}
              <span className="link-name" style={{ color: textColor }}>{link.name}</span>
            </a>
          );
        })}
      </div>
    );
  }

  // 默认：网格
  return (
    <div className="label-content-related-links">
      <div className="links-grid">
        {enabledLinks.map((link, idx) => (
          <a key={idx} href={link.url} className="related-link-item" target="_blank" rel="noreferrer" style={cardStyle}>
            {link.icon && <span className="link-icon">{link.icon}</span>}
            <span className="link-name" style={{ color: textColor }}>{link.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
